type PageObject = {
  name: string
  description: string
}

type ImpactModulePages = {
  [key: string]: PageObject
}

export const ATTENDANCES_PAGES: ImpactModulePages = {
  DASHBOARD: {
    name: 'Relatórios',
    description: 'Gestão dos relatórios',
  },
  RECEPTION: {
    name: 'Recepção',
    description: 'Gestão das ações do recepcionista no atendimento',
  },
  PROFESSIONAL: {
    name: 'Atendimento presencial',
    description: 'Gestão das ações do profissional no atendimento presencial',
  },
  FIELD: {
    name: 'Atendimento em campo',
    description: 'Gestão das ações do profissional no atendimento em campo',
  },
  ONLINE: {
    name: 'Teleatendimento',
    description: 'Gestão das ações do profissional no teleatendimento',
  },
  PANEL: {
    name: 'Painéis',
    description: 'Gestão dos painéis do módulo de atendimento',
  },
  CASE_TRACKING: {
    name: 'Acompanhamento de casos',
    description: 'Gestão dos acompanhamento de casos',
  },
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupo',
    description: 'Gestão das permissões de grupos',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões de agentes',
    description: 'Gestão das permissões dos agentes',
  },
  REVIEW: {
    name: 'Avaliações',
    description: 'Gestão das avaliações',
  },
  PLACE: {
    name: 'Locais',
    description: 'Gestão dos locais',
  },
  ROLE: {
    name: 'Papéis',
    description: 'Gestão dos papéis',
  },
  ACTIVITY_TYPE: {
    name: 'Tipos de atividades',
    description: 'Gestão dos tipos de atividades',
  },
}
